import {useEffect, useState} from 'react';
import {Modal, Button, Form, Input,  Popconfirm, message} from 'antd';
import {useApi} from "../provider/ApiProvider";
import CustomerSelector from "../components/CustomerSelector";
import QRCode from "react-qr-code";
import crypto from "crypto";

const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 16 },
};

const {TextArea} = Input;

export default function CompanyDialog({open, data, onChange, onClose,type}){

    const {api} = useApi();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        console.log(data,type,222)
        form.setFieldsValue(data);
    },[data])

    const handleQr = () => {
        form.setFieldsValue( {'qrCode': crypto.randomBytes(20).toString('hex') });
        Object.assign(data, { qrCode: crypto.randomBytes(20).toString('hex') })
        form.setFieldsValue({ data })
        handleOk()
    };
    const handleOk = () => {


    };

    const handleCancel = () => {
        onClose()
    };

    const onFinish = (values) => {
       values.city = 11;
       values.district = 11;
       values.qrCode = data?.qrCode ;

       if(data === null){
           setLoading(true);
           api.post("/companyRouter/company/store",values).then(resp => {
               onClose();
               onChange();
               setLoading(false);
           }).finally(() => {
               setLoading(false);
           })
       }else{
           setLoading(true);
           console.log(values,333)
           api.put("/companyRouter/company/update/" + data.id,values).then(resp => {
               onClose();
               onChange();
               setLoading(false);
           }).finally(() => {
               setLoading(false);
           })
       }

    };

    const onFinishFailed = (errorInfo) => {

    }

    const onDelete = (record) => {


    }



    return (
        <Modal
            title={type === "qr" ? "Kod Oluştur" : (data === null || data === undefined) ? "Firma / Şube Ekle" : "Düzenle"}
            visible={open} okType={"submit"}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button  style={{display: type === "qr" ? "block" : "none"}} form="company-dialog-form" htmlType="submit" key="submit" type="primary" loading={loading} onClick={handleQr} >
                    Code Oluştur
                </Button>,
                <Button style={{display: type === "qr" ? "none" : "block"}}  key="back" onClick={handleCancel}>
                    İptal
                </Button>,


                <Button style={{display: type === "qr" ? "none" : "block"}}  form="company-dialog-form" htmlType="submit" key="submit" type="primary" loading={loading} onClick={handleOk}>
                    Kaydet
                </Button>,
            ]}
        >



            <Form
                form={form}
                id="company-dialog-form"
                onFinish={onFinish}
                onFinishFailed={() => onFinishFailed("İstenen bilgileri giriniz")}
                initialValues={data}
            >
                <Form.Item    style={{display: type === "qr" ? "none" : "block"}}
                    label="Adı"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: 'Bu alanı doldurunuz',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item    style={{display: type === "qr" ? "none" : "block"}}
                    label="Telefon"
                    name="phone"
                    rules={[
                        {
                            required: true,
                            message: 'Bu alanı doldurunuz',
                        },
                    ]}
                >
                    <Input  />
                </Form.Item>


                <Form.Item    style={{display: type === "qr" ? "none" : "block"}}
                    label="Adres"
                    name="address"
                    rules={[
                        {
                            required: true,
                            message: 'Bu alanı doldurunuz',
                        },
                    ]}
                >
                    <TextArea />
                </Form.Item>
                <Form.Item    style={{display: type === "qr" ? "none" : "block"}}
                    label="Enlem"
                    name="latitude"
                    rules={[
                        {
                            required: true,
                            message: 'Bu alanı doldurunuz',
                        },
                    ]}
                >
                    <Input type={"number"} />
                </Form.Item>
                <Form.Item  style={{display: type === "qr" ? "none" : "block"}}
                    label="Boylam"
                    name="longitude"
                    rules={[
                        {
                            required: true,
                            message: 'Bu alanı doldurunuz',
                        },
                    ]}
                >
                    <Input type={"number"} />
                </Form.Item>
                <Form.Item  style={{display: type === "qr" ? "none" : "block"}}
                    label="Müşteri"
                    name="CustomerId"
                    rules={[
                        {
                            required: true,
                            message: 'Müşteri seçiniz',
                        },
                    ]}
                >
                    <CustomerSelector style={{display: type === "qr" ? "none" : "block"}}
                        value={form.getFieldValue('CustomerId')}
                        onChange={(id, value) =>{
                            form.setFieldsValue({ CustomerId: id });
                            form.setFieldsValue({ PlatformId: value?.PlatformId, PlatformName: value?.Platform?.name })
                        }}
                    />
                </Form.Item>
                <Form.Item style={{display: type === "qr" ? "none" : "block"}}
                    label="Platform"
                    name="PlatformName"
                    rules={[
                        {
                            // required: true,
                            // message: 'Bu alanı doldurunuz',

                        },
                    ]}
                >
                    <Input type={"string"} disabled />
                </Form.Item>
                <Form.Item
                    style={{display: 'none'}}
                    label="Platform"
                    name="PlatformId"
                    rules={[
                        {
                            required: true,
                            message: 'Bu alanı doldurunuz',

                        },
                    ]}
                >
                    <Input style={{display: type === "qr" ? "none" : "block"}} type={"hidden"} disabled />
                </Form.Item>
                <Form.Item>
                    {
                        data?.qrCode ?

                        <QRCode
                            size={256}
                            style={{ height: "auto", maxWidth: "100%", width: "100%" ,display: type === "qr" ? "block" : "none"  }}
                            value={data?.qrCode }
                            viewBox={`0 0 256 256`}
                        /> :

                            <Input type={"hidden"} disabled />
                    }

                    <Input type={"hidden"} disabled />

                </Form.Item>
                </Form>
        </Modal>

    )
}
